import Vue from 'vue'
import axios from 'axios'
import store from '@/store'

// Configuração base do Axios
const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_URL_CLIENT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

// Contador de requisições ativas
let activeRequests = 0

// Request interceptor
axiosIns.interceptors.request.use(
  config => {
    // Incrementa o contador de requisições ativas
    activeRequests += 1

    // Atualiza o estado de loading
    if (activeRequests === 1) {
      store.commit('app/TOGGLE_OVERLAY', true)
    }

    return config
  },
  error => Promise.reject(error),
)

// Response interceptor
axiosIns.interceptors.response.use(
  response => {
    // Decrementa o contador de requisições ativas
    activeRequests -= 1

    // Se não houver mais requisições ativas, desativa o loading
    if (activeRequests <= 0) {
      store.commit('app/TOGGLE_OVERLAY', false)
      activeRequests = 0 // Garante que o contador não fique negativo
    }

    return response
  },
  error => {
    // Decrementa o contador mesmo em caso de erro
    activeRequests -= 1

    // Se não houver mais requisições ativas, desativa o loading
    if (activeRequests <= 0) {
      store.commit('app/TOGGLE_OVERLAY', false)
      activeRequests = 0 // Garante que o contador não fique negativo
    }

    return Promise.reject(error)
  },
)

// Adiciona a instância do Axios ao Vue prototype
Vue.prototype.$http = axiosIns

export default axiosIns
